export default __webpack_public_path__ + "static/media/Eye_3_M_C5.b9e1e949.svg";